import { useCallback, useRef, useState } from 'react';

// Can detect if user is hovering a nested element
// E.g. if a user is hovering a child of the concerned element
export function useNestedHover(delayMs?: number) {
  const [isHovered, setIsHovered] = useState(false);
  const timeRef = useRef<number>();
  const onMouseEnter = useCallback(() => {
    const now = Date.now();
    timeRef.current = now;
    setTimeout(() => now === timeRef.current && setIsHovered(true), delayMs);
  }, [delayMs]);
  const onMouseLeave = useCallback(() => {
    setIsHovered(false);
    timeRef.current = undefined;
  }, []);
  return { isHovered, onMouseEnter, onMouseLeave };
}

export type NestedHoverBag = ReturnType<typeof useNestedHover>;
